module.exports = __webpack_public_path__ + "img/arrow-right.ba92a1ec.svg";